import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Iphone from '../pages/Iphone';
import Layout from './Layout';




function App() {
  return (
    <React.Fragment>
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/iphone" element={<Iphone />} exact />
          </Routes>
        </Layout>
      </BrowserRouter>
    </React.Fragment>

  );
}



export default App;